






















































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getUsers, deleteUser, patchUser, getBusinessDevelopers, getPrescribersCompanies, postPrescriberSubscriptionCancel, getUserNewTrial, postAdminUserTokenGenerate, patchAdminUserTokenRegenerate } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import User from '../models/User';
import AuthModule from '../store/AuthModule';
import get from 'lodash/get';
import { roles, formatRoles } from '@/data/roles';
import Datatable from '@/components/Datatable.vue';
import Boolean from '@/components/Boolean.vue';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import Subscription from '@/models/Subscription';
import FilterComponent from '@/components/FilterComponent.vue';
import Company from '@/models/Company';
import UserToken from '@/models/UserToken';

@Component({
    components: {
        Datatable,
        Boolean,
        FilterComponent,
    },
    filters: {
        formatRoles,
        formatFamily: (value: string) => {
            return value.substring(0, 30);
        },
        formatDateTime: (value: string) => {
            return value ? moment(value).format('DD/MM/YYYY - HH:mm') : null;
        },
        formatSeniority(months: number) {
            /**if (
                prescriber.subscriptions &&
                prescriber.subscriptions.length > 0
            ) {
                const diff = moment.duration(
                    moment(moment()).diff(prescriber.subscriptions[0].start_at),
                );

                const months = diff.months();
                const years = diff.years();
                if (years === 0) {
                    return `${months} mois`;
                }
                return `${months} mois et ${years} année${
                    years > 1 ? 's' : ''
                }`;
            }*/
            if(months >= 12) {
              let years = Math.trunc(months / 12);
              let cc = ' An'
              if(years > 1) {
                cc = ' Ans'
              }
              return years + cc;
            }
            return months + ' Mois';
        },
        getEndAtSubscription(subcriptions: Subscription[]) {
            if (subcriptions.length > 0) {
                const lastSubcription = subcriptions[subcriptions.length - 1];
                const value = lastSubcription.end_at;
                return value ? moment(value).format('DD/MM/YYYY - kk:mm') : null;
            }
            return null;
        },
      getMonthSub(subscriptions: Subscription[]) {
        if (subscriptions.length > 0) {
          const lastSubcription = subscriptions[subscriptions.length - 1];
          const endDate = lastSubcription.end_at!.toString();
          const startDate = lastSubcription.start_at!.toString();
          if(typeof endDate !== undefined && typeof startDate !== undefined) {
            let end = new Date(endDate);
            let start = new Date(startDate);
            let diffYears = end.getFullYear()-start.getFullYear();
            let diffMonths = end.getMonth()-start.getMonth();
            let months = (diffYears*12 + diffMonths);
            return months;
          }
        }
        return null;
      }
    },
})
export default class Prescribers extends Vue {
    daysToAddPopUp: boolean = false;
    daysToAdd: number = 0;
    userAddToAddPopup: User| null = null;
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: { 
            roles: 'ROLE_PRESCRIBER',
            year: new Date().getFullYear().toString()
        },
        exclusions: null,
    };
    textMessage: string = '';
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns = [
        {
            title: 'Nom',
            dataIndex: 'lastname',
            scopedSlots: {
                customRender: 'lastname',
            },
            sorter: true,
        },
        {
          title: 'Date Création',
          dataIndex: 'created_at',
          scopedSlots: {
            customRender: 'created_at',
          },
          sorter: true,
        },
        {
          title: 'Dernière connexion',
          dataIndex: 'last_login',
          scopedSlots: {
            customRender: 'datetime',
          },
          sorter: true,
        },
        {
          title: 'Date fin Abonnement',
          dataIndex: 'subscriptions',
          scopedSlots: {
            customRender: 'subscriptions',
          },
          sorter: true,
        },
        {
            title: 'Vérifié',
            dataIndex: 'enabled',
            scopedSlots: {
                customRender: 'boolean',
            },
            sorter: true,
        },
        {
            title: 'Type Accès',
            dataIndex: '',
            scopedSlots: {
                customRender: 'account',
            },
            sorter: true,
        },
        {
            title: 'BD',
            dataIndex: 'business_developper.firstname',
            sorter: true,
        },
        {
            title: '100% autonome',
            dataIndex: 'autonomous',
            scopedSlots: {
                customRender: 'autonomous',
            },
            sorter: true,
        },
        {
            title: 'Statut / Famille Prescripteur',
            dataIndex: 'family',
            sorter: true,
            scopedSlots: {
              customRender: 'family',
            },
        },
        {
            title: 'Nb Mois',
            dataIndex: 'prescriber_seniority',
            scopedSlots: {
                customRender: 'date',
            },
            sorter: true,
        },
        {
            title: 'Actes 12 der. Mois',
            dataIndex: 'current_year_total_sales',
            sorter: true,
        },
        {
            title: 'Options 12 der. Mois',
            dataIndex: 'current_year_total_options',
            sorter: true,
        },
        {
            title: 'Nb Tel.',
            dataIndex: 'nb_archive_downloaded',
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];
    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    yearModel: string = new Date().getFullYear().toString();
    statusPrescriberModel: string | undefined | null = null;
    accesTypeModel: string | undefined | null = null;
    businessDevelopperModel: string | undefined | null = null;
    autonomousModel: string | undefined | null = null;
    prescriberCompanyModel: string | undefined | null = null;
    verifiedModel: string | undefined | null = null;

    isJc(subscriptions: []) {
        const lastSubcription = subscriptions[subscriptions.length - 1];
        //console.log(lastSubcription);
        //@ts-ignore
        if(lastSubcription.is_jc) {
            return true;
        }
        return false;
    }

    async addTrial(user: User, daysToAdd: number) {
        
        if(user && user.id) {
            await getUserNewTrial(user.id, daysToAdd);
            user.is_trial_active = true;
        }
        this.daysToAddPopUp = false;
        this.daysToAdd = 0;
    }

    async activeDaysToAddPopup(user : User){
        this.userAddToAddPopup = user;
        this.daysToAddPopUp = true;
    }

        get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years = [];
        
        for (let year = currentYear; year >= 2021; year--) {
            years.push({
                text: year.toString(),
                value: year.toString()
            });
        }
        
        return years;
    }

        @Watch('yearModel', { immediate: true })
    onYearModel() {
        if (this.yearModel) {
            this.meta.filters = {
                ...this.meta.filters,
                year: this.yearModel
            };
        }
    }

    get statusPrescripteurValues() {
        return [
            { text: 'CGPi', value: 'CGPi' },
            { text: 'CGP Mandataire', value: 'CGP Mandataire' },
            {
                text: 'Conseiller Immobilier Neuf carte T',
                value: 'Conseiller Immobilier Neuf carte T',
            },
            {
                text: 'Conseiller Immobilier Neuf Mandataire',
                value: 'Conseiller Immobilier Neuf Mandataire',
            },
            { text: 'CIF', value: 'CIF' },
            {
                text: 'Agent Immobilier Ancien Carte T',
                value: 'Agent Immobilier Ancien Carte T',
            },
            {
                text: 'Mandataire Immobilier Ancien',
                value: 'Mandataire Immobilier Ancien',
            },
        ];
    }

    async fetch(meta: MetaDatatable) {
        this.meta.filters.role = 'ROLE_PRESCRIBER';
        const { data } = await getUsers({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }

    async fetchBusinessDevelopper(){
        const dataBusinessDeveloppers = await getBusinessDevelopers();
        return dataBusinessDeveloppers.data.map(
            (item: User) => ({
                text: item.firstname  + " - " + item.email,
                value: item.id || 0,
            })
        );
    }

    async fetchCompanyPrescriber(){
        const companyPrescriber = await getPrescribersCompanies();
        return companyPrescriber.data.map(
            (item: Company) => ({
                text: item.name,
                value: item.id || 0,
            })
        );
    }

    deleteText = {
        confirm: {
            title: `Suppression de le prescripteur`,
            content: `Voulez-vous vraiment supprimer le prescripteur ?`,
        },
        notify: {
            title: 'Prescripteur supprimé',
            content: `Le prescripteur a bien été supprimé`,
        },
    };

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: User | null;
    }) {
        const action = ev.action;
        const user: User | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (user !== null) {
                    this.$router.push({
                        name: 'editPrescriber',
                        params: {
                            id: `${user.id}`,
                        },
                    });
                }
                break;
            case 'delete':
                if (user && user.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deleteUser(user.id);
                }
                break;
        }
    }

    deleteDialog(user: User) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(user),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async cancelSub(user: User) {
        const $vs = (this as any).$vs;
        if (user && user.id) {
            try {
                await postPrescriberSubscriptionCancel(user.id);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Succes',
                    text: 'Abonnement Annulé',
                });
            } catch (e) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: 'nous ne parvenons pas à supprimer l\'abonnement de cet utilisateur',
                });
            }
        }
    }

    async resetD(user: User, type: string) {
        const $vs = (this as any).$vs;
        if (user && user.id) {
            try {
              if(type == 'download'){
                user.nb_archive_downloaded = 0;
                this.textMessage = `Réinitialisation des téléchargements du prescripteur ${
                    user.lastname
                } ${user.firstname} effectuée`
              }
                await patchUser(user.id, user);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Téléchargements réinitialisés',
                    text: this.textMessage,
                });
            } catch (error) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: this.textMessage,
                });
            }
        }
    }

    async outdatedPrescriber(user: User) {
        const $vs = (this as any).$vs;
        if (user && user.id) {
            try {
                user.is_trial_active = false;
                user.is_subscription_active = false;
                await patchUser(user.id, user);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Prescripteur périmé',
                    text: `Passage du prescripteur ${
                        user.lastname
                    } ${user.firstname} en périmé réussi`,
                });
            } catch (error) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: this.textMessage,
                });
            }
        }
    }

    haveValidUserTokens(record: any){
        if(record.user_tokens !== 'undefined'){
            for(const i in record.user_tokens) {
              if(!record.user_tokens[i].deleted_at) {
                return true;
              }
            }
        }
        return false;
    }

    PluginMapDialog(user: User) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: "Generation des acces plugin Carte",
            text: "Etes vous sur de vouloir généré les accès au plugin Carte ?",
            accept: () => this.generateCredentialsPluginMap(user),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async generateCredentialsPluginMap(user: User){
        const $vs = (this as any).$vs;
        try {
            const {data} = await postAdminUserTokenGenerate(user);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Les Accès au plugin Carte ont bien été crée',
                text: `Acces Plugin : Login ${
                    data.login
                } Clé API ${data.token}`,
            });
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: "une erreur c'est produite lors de lPluginMapDialogRefresh génération des clés d'accès",
            });
        }
    }

    PluginMapDialogRefresh(user: User) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: "Regeneration des accès plugin Carte",
            text: "Etes vous sur de vouloir regénéré les accès au plugin Carte ? cette action est irréversible",
            accept: () => this.regenerateCredentialsPluginMap(user),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async regenerateCredentialsPluginMap(user: User){
        const $vs = (this as any).$vs;
        let userTokenId: any = 0;
        for(const i in user.user_tokens) {
            const key = Number(i);
            if(!user.user_tokens[key].deletedAt) {
                userTokenId = user.user_tokens[key].id;
            }
        }
        try {
            const {data} = await patchAdminUserTokenRegenerate(userTokenId);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Les Accès au plugin Carte ont bien été regénéré',
                text: `Acces Plugin : Login ${
                    data.login
                } Clé API ${data.token}`,
            });
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: "une erreur c'est produite lors de la regénération des clés d'accès",
            });
        }
    }

    async acceptDeleteAlert(user: User) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: user });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression du prescripteur`,
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    getPrescriberStatus(prescriber: User): any | 'trial' | 'outdated' {
  if (prescriber.is_subscription_active) {
    // @ts-ignore
    let sub!: Subscription[] = prescriber.subscriptions;
    if (sub.length > 0) {
      const lastSubcription = sub[sub.length - 1];
      const endDate = lastSubcription.end_at!.toString();
      const startDate = lastSubcription.start_at!.toString();
      if (typeof endDate !== undefined && typeof startDate !== undefined) {
        let end = new Date(endDate);
        let start = new Date(startDate);
        let diffYears = end.getFullYear() - start.getFullYear();
        let diffMonths = end.getMonth() - start.getMonth();
        let months = (diffYears * 12 + diffMonths);
        return 'subscribed months_' + months; // On retourne le statut souscrit avec les mois
      }
    }
  } else if (prescriber.is_trial_active) {
    return 'trial'; // Si c'est un essai
  } else {
    // Si l'abonnement est périmé
    //@ts-ignore
    let sub!: Subscription[] = prescriber.subscriptions;
    if (sub.length > 0) {
      const lastSubcription = sub[sub.length - 1];
      const endDate = lastSubcription.end_at!.toString();
      const startDate = lastSubcription.start_at!.toString();
      if (typeof endDate !== undefined && typeof startDate !== undefined) {
        let end = new Date(endDate);
        let start = new Date(startDate);
        let diffYears = end.getFullYear() - start.getFullYear();
        let diffMonths = end.getMonth() - start.getMonth();
        let months = (diffYears * 12 + diffMonths);
        return 'Périmé ' + months + ' Mois'; // Retourne l'état périmé avec le nombre de mois
      }
    } else {
      return 'outdated'; // Si l'abonnement est absent
    }
  }
}



getLastSubscription(prescriber: User): Subscription {
  // On s'assure que la dernière souscription existe
  const subscriptions = prescriber.subscriptions || [];
  return subscriptions.length > 0 ? subscriptions[subscriptions.length - 1] : {} as Subscription;
}



    created() {
        this.accesTypeModel = undefined;
        this.autonomousModel = undefined;
        this.businessDevelopperModel = undefined;
        this.prescriberCompanyModel = undefined;
        this.statusPrescriberModel = undefined;
        this.verifiedModel = undefined;
        this.yearModel = new Date().getFullYear().toString();
    }

    @Watch('meta', { deep: true })
    onMeta() {
        if (this.meta.filters) {
            if (this.meta.filters.accessType) {
                this.accesTypeModel = `${this.meta.filters.accessType}`;
            }
            if (this.meta.filters.autonomous) {
                this.autonomousModel = this.meta.filters.autonomous;
            }
            if (this.meta.filters.bdPrescriber) {
                this.businessDevelopperModel = this.meta.filters.bdPrescriber;
            }
            if (this.meta.filters.company) {
                this.prescriberCompanyModel = this.meta.filters.company;
            }
            if (this.meta.filters.statusPrecriber) {
                this.statusPrescriberModel = this.meta.filters.statusPrecriber;
            }
            if (this.meta.filters.verified) {
                this.verifiedModel = this.meta.filters.verified;
            }
            if (this.meta.filters.year) {
                this.yearModel = this.meta.filters.year;
            } else {
                this.yearModel = new Date().getFullYear().toString();
            }
        }
    }

    onFilterAccestype(value: string | undefined) {
        if (value) {
            this.accesTypeModel = value;
            this.meta.filters = {
                accessType: value,
            };
        } else {
            this.accesTypeModel = undefined;
            this.meta.filters = {
                accessType: undefined,
            };
        }
    }

    onFilterAutonomous(value: string | undefined) {
        if (value) {
            this.autonomousModel = value;
            this.meta.filters = {
                autonomous: value,
            };
        } else {
            this.autonomousModel = undefined;
            this.meta.filters = {
                autonomous: undefined,
            };
        }
    }

    onFilterBusinessDevelopper(value: string | undefined) {
        if (value) {
            this.businessDevelopperModel = value;
            this.meta.filters = {
                bdPrescriber: value,
            };
        } else {
            this.businessDevelopperModel = undefined;
            this.meta.filters = {
                bdPrescriber: undefined,
            };
        }
    }

    onFilterCompany(value: string | undefined) {
        if (value) {
            this.prescriberCompanyModel = value;
            this.meta.filters = {
                company: value,
            };
        } else {
            this.prescriberCompanyModel = undefined;
            this.meta.filters = {
                company: undefined,
            };
        }
    }

    onFilterVerified(value: string | undefined) {
        if (value) {
            this.verifiedModel = value;
            this.meta.filters = {
                verified: value,
            };
        } else {
            this.verifiedModel = undefined;
            this.meta.filters = {
                verified: undefined,
            };
        }
    }

    onFilterStatusPrescriber(value: string | undefined) {
        if (value) {
            this.statusPrescriberModel = value;
            this.meta.filters = {
                statusPrescriber: value,
            };
        } else {
            this.statusPrescriberModel = undefined;
            this.meta.filters = {
                statusPrescriber: undefined,
            };
        }
    }
}
